import React, { useState, useEffect, ChangeEvent } from 'react'
import NumberFormat from 'react-number-format'

import { useStoreActions, useStoreState } from 'store'

export default function ZipCode(props: JSX.IntrinsicAttributes & { className?: string }) {
  const { onInputTracking } = useStoreActions(actions => actions.tracking)
  const zipCode = useStoreState(state => state.dimensions.dimensions.zipCode)
  const [currentZipCode, setCurrentZipCode] = useState(zipCode)
  const updateLocation = useStoreActions(actions => actions.location.update)
  const updateDimensions = useStoreActions(actions => actions.dimensions.updateDimensions)
  const dimensionsValidation = useStoreState(state => state.dimensions.dimensionsValidation)

  const onChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    setCurrentZipCode(value)

    await updateLocation(value)

    updateDimensions({ zipCode: value })
    onInputTracking({ name: 'zipcode', type: 'ZIPCODE', label: 'zip code', value })
  }

  useEffect(() => {
    setCurrentZipCode(zipCode)
  }, [zipCode])

  return (
    <div
      className={`FormControl ${props.className} ${dimensionsValidation.zipCode.invalid && 'is-error'}`}
      style={{ maxWidth: 'initial' }}
    >
      <label className="FormLabel" htmlFor="zipCode">
        ZIP code
      </label>
      <NumberFormat
        value={currentZipCode}
        onChange={onChange}
        data-testid="zipCode"
        className="FormInput --zip"
        id="zipCode"
        inputMode="numeric"
        pattern="[0-9,]*"
        allowLeadingZeros={true}
      />
      {dimensionsValidation.zipCode.invalid && (
        <span
          data-testid="zipCodeError"
          className="FormElementHelp is-error pos-absolute pt-1"
          style={{ fontSize: '12px', lineHeight: '1' }}
        >
          {dimensionsValidation.zipCode.errorMsg}
        </span>
      )}
    </div>
  )
}
